<a [routerLink]="resolveRouterLink(route)" [queryParams]="queryParams">{{ label }}</a>